<template>
  <div class="nettdoc-dizziness">
    <SectionHeader 
      text="I'm feeling dizzy" 
      img="illu-card-beschwerden-dizzy" 
      alt="dizzy face" 
      :collapsable="true" 
      v-on:collapse="collapsed = !collapsed"
      :complete="store.dizzinessDetails.submitted"
    />

    <template v-if="collapsed">
      <SectionHeader text="Since when do you feel dizzy?" :dark="true" :required="true" />
      <Dropdown
        label="please choose"
        :data="['Few hours', '1 day', '2 to 6 days', 'More than one week', '1 month']"
        :choice="store.dizzinessDetails.since"
        v-on:action="value => store.addDizzinessDetails('since', value)"
      />

      <SectionHeader text="When does the dizzyness mainly occur?" :required="true" :dark="true" />
      <CheckboxList 
        :data="['When I turn my head', 'When I am lying down', 'When I get from sitting or lying down', 'When I bend down']"
        :choice="store.dizzinessDetails.when"
        v-on:action="value => store.addDizzinessDetails('when', value, true)"          
      />

      <SectionHeader text="sickOrThrewUp" :dark="true" :required="false" />
      <YesNo
        :model="store.dizzinessDetails.sickOrThrewUp"
        v-on:action="value => store.addDizzinessDetails('sickOrThrewUp', value)"
      />

      <SectionHeader text="hearingWorse" :dark="true" :required="false" />
      <YesNo
        :model="store.dizzinessDetails.hearingWorse"
        v-on:action="value => store.addDizzinessDetails('hearingWorse', value)"
      />

      <SectionHeader text="earSounds" :dark="true" :required="false" />
      <YesNo
        :model="store.dizzinessDetails.earSounds"
        v-on:action="value => store.addDizzinessDetails('earSounds', value)"
      />

      <template v-if="store.dizzinessDetails.earSounds === 'yes'">
        <SectionHeader text="earSoundsOn" :required="false" :dark="true" />
        <CheckboxList 
          :data="['Left ear', 'Right ear']"
          :choice="store.dizzinessDetails.earSoundsOn"
          v-on:action="value => store.addDizzinessDetails('earSoundsOn', value, true)"          
        />
      </template>

      <SectionHeader text="threwUp" :dark="true" :required="true" />
      <YesNo
        :model="store.dizzinessDetails.threwUp"
        v-on:action="value => store.addDizzinessDetails('threwUp', value)"
      />

      <SectionHeader text="lostConciousness" :dark="true" :required="true" />
      <YesNo
        :model="store.dizzinessDetails.lostConciousness"
        v-on:action="value => store.addDizzinessDetails('lostConciousness', value)"
      />

      <template v-if="store.dizzinessDetails.lostConciousness === 'yes'">
        <SectionHeader text="lostConciousnessCount" :dark="true" :required="false" />
        <Dropdown
          label="please choose"
          :data="['Once', 'One to three times', 'More than 3 times']"
          :choice="store.dizzinessDetails.lostConciousnessCount"
          v-on:action="value => store.addDizzinessDetails('lostConciousnessCount', value)"
        />

        <SectionHeader text="lostConciousnessHeartRacing" :dark="true" :required="false" />
        <TripleChoice
          :model="store.dizzinessDetails.lostConciousnessHeartRacing"
          v-on:action="value => store.addDizzinessDetails('lostConciousnessHeartRacing', value)"
        />

        <SectionHeader text="lostConciousnessEarSounds" :dark="true" :required="false" />
        <TripleChoice
          :model="store.dizzinessDetails.lostConciousnessEarSounds"
          v-on:action="value => store.addDizzinessDetails('lostConciousnessEarSounds', value)"
        />

        <SectionHeader text="lostConciousnessHotCold" :dark="true" :required="false" />
        <TripleChoice
          :model="store.dizzinessDetails.lostConciousnessHotCold"
          v-on:action="value => store.addDizzinessDetails('lostConciousnessHotCold', value)"
        />
      </template>

      <Button :text="edit ? 'Update' : 'Submit'" v-on:action="submit" :active="store.dizzinessDetailsComplete" />
    </template>
  </div>
</template>

<script>
import { observer } from "mobx-vue";

import SectionHeader from "../SectionHeader";
import YesNo from "../YesNo";
import Button from "../Button";
import Dropdown from "../Dropdown";
import NumberInput from "../NumberInput";
import TripleChoice from "../TripleChoice";
import CheckboxList from "../CheckboxList";
export default observer({
  name: "Dizziness",
  data() {
    return {
      collapsed: true
    };
  },
  props: {
    store: Object,
    edit: Boolean
  },
  components: {
    SectionHeader, YesNo, Button, Dropdown, NumberInput, TripleChoice, CheckboxList
  },
  methods: {
    submit: function() {
      this.store.dizzinessDetails.submitted = true
      localStorage.setItem(
        "dizzinessDetails",
        JSON.stringify(this.store.dizzinessDetails)
      )
      if (this.edit) {
        this.$emit('close')
      } else {
        this.collapsed = !this.collapsed
        window.scrollTo(0,0)
      }
    }
  }
})
</script>

<style>

</style>